import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.75 15.25H4.5a3.75 3.75 0 0 1 0-7.5h2.25v7.5Zm0 0a22.3 22.3 0 0 1 12.366 3.744l1.134.756V3.25l-1.134.756A22.3 22.3 0 0 1 6.75 7.75v7.5ZM23.25 10v3m-16.5 2.25A7.24 7.24 0 0 0 9 20.5",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M6.75%2015.25H4.5a3.75%203.75%200%200%201%200-7.5h2.25v7.5Zm0%200a22.3%2022.3%200%200%201%2012.366%203.744l1.134.756V3.25l-1.134.756A22.3%2022.3%200%200%201%206.75%207.75v7.5ZM23.25%2010v3m-16.5%202.25A7.24%207.24%200%200%200%209%2020.5%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
